import { defineSlotRecipe } from '@chakra-ui/react';

export const tableSlotRecipe = defineSlotRecipe({
  slots: ['root', 'header', 'body', 'row', 'columnHeader', 'cell', 'footer', 'caption'],
  variants: {
    dlms: {
      true: {
        row: {
          '&:hover td': {
            bg: '#fff0c9 !important',
            color: 'inherit',
            cursor: 'default'
          }
        },
        cell: {
          padding: '6px'
        },
        columnHeader: {
          bg: 'primary',
          color: 'white',
          fontWeight: 'bold',
          padding: '6px',
          textAlign: 'left',
          '& div > div': {
            bg: 'primary !important',
            color: 'white'
          }
        }
      }
    }
  },
  defaultVariants: {
    dlms: true
  }
});
